import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button, Select, Tag , Dropdown, Menu, message, Tooltip} from "antd";
import { Row, Col } from "reactstrap";
import "./BottomBar.css"; // Include any custom styling here
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCalendarAlt,
  faDotCircle,
  faTrashAlt,
  faCopy,
  faPrint, 
  faFileExport
} from "@fortawesome/free-solid-svg-icons";
import AwsServerService from "../../common/util/AwsServerService";
import swal from "sweetalert";
import { CloseOutlined, FlagFilled, DownOutlined } from "@ant-design/icons";
import { UserPicker } from "../../common/UserPicker/UserPicker";
import { convertToUSTime, getPriorityValue } from "../HR/TimeClock/Util";
import { Option } from "antd/es/mentions";
import TaskService from "../../common/util/TaskService";
import AppContext from "../../Context/AppContext";
import { useDispatch, useSelector } from "react-redux";
import { setNotificationFlag } from "../../Context/ReduxContext";
import { faClone } from "@fortawesome/free-regular-svg-icons";
import { useHistory } from "react-router-dom";
import RenderSettingsPopoverContent from "../../tabs/Task/RenderSettingPopoverContent";
import { canAccess, getTaskAccess } from "../../common/util/appUtils";
import { AppDataRequired } from "../../App";
const BottomBar = ({
  selectedIds,
  setSelectedIds,
  setPageRefreshData,
  selectedTable,
  subTaskData,
  setSubTaskData,
  setIsAdding,
  allPipelineData,
  setSubEditData,
  setUpdateFlag,
  DealName,
  allTasksAndSubtasks
}) => {
  // console.log("selectedIds bottom bar", selectedIds);
  const { AllUsers } = useContext(AppDataRequired);
  const reduxDispatch = useDispatch();
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const getNotification = useSelector((state) => state.AppReduxContext.getNotificationFlag);
  const AllDeals = useSelector((state) => state.AppReduxContext.AllDeals);
  const user = JSON.parse(localStorage.getItem('userinfo'));
  const AppData = useContext(AppContext);
  const history = useHistory()
  const { dispatch, state } = AppData || {};
  let count =
    Number(selectedIds?.Task?.length) + Number(selectedIds?.Subtask?.length);

    const handleCreateNotification = async (notifyArraytoPass ,AllUsers, task , deal,datafor, text) =>{
      
      await TaskService.SendAssignedNotification(notifyArraytoPass ,AllUsers, task , deal,datafor , text )
        .then((e) => {
          reduxDispatch(setNotificationFlag(!getNotification));
        })
        .catch((e) => {
          console.log("e", e);
        });
    }

    const DeleteTasks = async () => {
      swal({
        title: "Are you sure you want to delete selected tasks/subtasks?",
        text: "",
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then(async function (isConfirm) {
        if (isConfirm) { 
          let taskDeletionPromises;
          let subtaskDeletionPromises;
          try {
            // Determine deletion promises based on the selected table type
            if (selectedTable === "tasks") {
              taskDeletionPromises = selectedIds?.Task?.length
                ? selectedIds.Task.map(async (item) => {
                  let subTaskDataFiltered = subTaskData?.filter((k) => k?.id !== item);
                  if (subTaskData && subTaskDataFiltered?.length !== subTaskData?.length) {
                      setSubEditData({
                        id: Date.now(),
                        Assignee: "",
                        Priority: "",
                        CREATEDBY: user.email_id,
                        Supervisor: "",
                        TaskDescription: "",
                        TaskName: "",
                        PipelineROWID: "",
                        TimeEstimate: "",
                        DueDate: convertToUSTime(new Date()),
                        StartDate: convertToUSTime(new Date()),
                      })
                      setSubTaskData(subTaskDataFiltered);  // Updating state here
                      return;
                    }
                    const pipeline = allPipelineData.find(pipeline =>
                      pipeline.Tasks.some(task => task.TaskROWID === item)
                    );
                    DealName.current = pipeline.DealName;
                    const task = pipeline.Tasks.find(task => task.TaskROWID === item);
                    const PipelineRowid = task.PipelineROWID;
                    const Position = task.Position;
                    await AwsServerService.deleteTask(item).then(async e=>{
                      if(task?.SubTasks?.length > 0){
                        await Promise.all(
                          task.SubTasks.map(async (sub) => {
                            // Check if the subtask ID is already in selectedIds.Subtask
                            if (!selectedIds.Subtask.includes(sub?.SubTaskROWID)) {
                              await AwsServerService.deleteSubtask(sub?.SubTaskROWID);
                            }
                          })
                        );
                      }
                     await AwsServerService.reorderTaskListPosition(PipelineRowid, Position);
                    }).catch(e=>{
                      console.log(e)
                    })
                  })
                : [];
    
              subtaskDeletionPromises = selectedIds?.Subtask?.length
                ? selectedIds.Subtask.map(async (item) => {
                    await AwsServerService.deleteSubtask(item); // Deleting subtask
                  })
                : [];
            } else {
              taskDeletionPromises = selectedIds?.Task?.length
                ? selectedIds.Task.map(async (item) => {
                  let subTaskDataFiltered = subTaskData?.filter((k) => k?.id !== item);
                    if (subTaskData && subTaskDataFiltered.length !== subTaskData.length ) {
                      setSubEditData({
                        id: Date.now(),
                        Assignee: "",
                        Priority: "",
                        CREATEDBY: user.email_id,
                        Supervisor: "",
                        TaskDescription: "",
                        TaskName: "",
                        PipelineROWID: "",
                        TimeEstimate: "",
                        DueDate: convertToUSTime(new Date()),
                        StartDate: convertToUSTime(new Date()),
                      })
                      setSubTaskData(subTaskDataFiltered); // Updating state here
                      return;
                    }
                    const pipeline = allPipelineData.find(pipeline =>
                      pipeline.Tasks.some(task => task.TaskROWID === item)
                    );
                    DealName.current = pipeline.DealName
                    const task = pipeline.Tasks.find(task => task.TaskROWID === item);
                    const PipelineRowid = task.PipelineROWID;
                    const Position = task.Position;
                    // console.log("taskkkk:", task)
                    await AwsServerService.deleteTaskInTemplate(item).then(async e=>{
                      if(task?.SubTasks?.length > 0){
                        await Promise.all(
                          task.SubTasks.map(async (sub) => {
                            // Check if the subtask ID is already in selectedIds.Subtask
                            if (!selectedIds.Subtask.includes(sub?.SubTaskROWID)) {
                              await AwsServerService.deleteSubtaskInTemplate(sub?.SubTaskROWID);
                            }
                          })
                        );
                      }
                     await AwsServerService.reorderTaskTemplatePosition(PipelineRowid, Position);
                    }).catch(e=>{
                      console.log(e)
                    })
                  })
                : [];
    
              subtaskDeletionPromises = selectedIds?.Subtask?.length
                ? selectedIds.Subtask.map(async (item) => {
                    if (subTaskData) {
                      subTaskData = subTaskData?.filter((k) => k?.SubTaskROWID !== item);
                      setSubTaskData(subTaskData); // Updating state here
                    }
                    await AwsServerService.deleteSubtaskInTemplate(item); // Deleting subtask in template
                  })
                : [];
            }
    
            // Wait for all deletions to complete
            await Promise.all([
              ...taskDeletionPromises,
              ...subtaskDeletionPromises,
            ]);
    
            // Now update the states after the deletion promises have resolved
            setSelectedIds({ Task: [], Subtask: [] });
            setPageRefreshData((prev) => !prev);
            setIsAdding(false);  // Make sure state updates happen after Promise.all resolves
          } catch (err) {
            console.log("Some error occurred deleting tasks or subtasks", err);
          }
        }
      });
    };

  const updateDataForFields = (e,field) =>{
    swal({
      title: `Are you sure you want to change the ${field}?`,
      text: "",
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    }).then(async function (isConfirm) {
      if (isConfirm) {
        try {
          if (selectedTable === "tasks") {
            // Process Tasks
            if (selectedIds?.Task?.length > 0) {
              // Perform bulk update for tasks
              await AwsServerService.updateAssignee(e, selectedIds?.Task, field, "Tasks").then(e=>{
                if(setUpdateFlag){
                  setUpdateFlag(prev => !prev);
                }
              }).catch(e=> console.log("e", e))
        
              // Send notifications for each task
              for (const taskId of selectedIds.Task) {
                const pipeline = allPipelineData.find(pipeline =>
                  pipeline.Tasks.some(task => task.TaskROWID === taskId)
                );
        
                if (!pipeline) {
                  console.error(`Pipeline not found for Task ID: ${taskId}`);
                  continue;
                }
        
                const deal = (AllDeals || []).find(
                  deal => deal.Deal_Name === pipeline.DealName
                );
        
                if (!deal) {
                  console.error(`Deal not found for Task ID: ${taskId}`);
                  continue;
                }
        
                // Find the task object corresponding to the selected task ID
                const task = pipeline.Tasks.find(task => task.TaskROWID === taskId);
        
                if (!task) {
                  console.error(`Task not found in pipeline for Task ID: ${taskId}`);
                  continue;
                }
              const taskType = task?.SubTaskROWID ? "Sub Task" : "Task"
              let zuidArr = [];
              let text = '';
              if(field == "Assignee"){
                text = '';
                zuidArr.push(e);
              }else if(field == "Supervisor"){
                text = `assigned you as supervisor in ${taskType}`
                zuidArr.push(e)
              }else if(field == "Priority"){
                const oldPriorityColor = getPriorityValue(task.Priority); // Get color for old priority
                const newPriorityColor = getPriorityValue(e); // Get color for new priority
                text = (
                  <>
                    changed priority from{' '}
                    <span style={{ color: oldPriorityColor, fontWeight: 'bold' , whiteSpace:"nowrap"}}>
                    <FlagFilled style={{ color: oldPriorityColor }} />{' '}
                      {task.Priority}
                    </span>{' '}
                    to{' '}
                    <span style={{ color: newPriorityColor, fontWeight: 'bold', whiteSpace:"nowrap" }}>
                    <FlagFilled style={{ color: newPriorityColor }} />{' '}
                      {e}
                    </span>
                    <span>{' '} in {taskType}</span>
                  </>
                );
                zuidArr = [...zuidArr, task.Assignee, task.Supervisor]
              }

                const renderToHtml = (element) =>
                  require('react-dom/server').renderToString(element);

                handleCreateNotification(zuidArr, state.AllAppUsers,task,deal, taskType,renderToHtml(text), allTasksAndSubtasks)
        
                // await TaskService.SendAssignedNotification(
                //   [e],       // Pass the full task object
                //   state.AllAppUsers,
                //   task,
                //   deal,
                //   "Task",
                //   text
                // ).then(() => {
                //   if (getNotification) {
                //     getNotification();
                //   }
                // }).catch(err => console.error(`Error sending notification for Task ID: ${taskId}`, err));
              }
            }
        
            // Process Subtasks
            if (selectedIds?.Subtask?.length > 0) {
              // Perform bulk update for subtasks
              await AwsServerService.updateAssignee(e, selectedIds?.Subtask, field, "SubTasks").then(e=>{
                if(setUpdateFlag){
                  setUpdateFlag(prev => !prev);
                }
              }).catch(e=> console.log("e", e))
        
              // Send notifications for each subtask
              for (const subtaskId of selectedIds.Subtask) {
                const pipeline = allPipelineData.find(pipeline =>
                  pipeline.Tasks.some(task =>
                    (task.SubTasks || []).some(subtask => subtask.SubTaskROWID === subtaskId)
                  )
                );
        
                if (!pipeline) {
                  console.error(`Pipeline not found for Subtask ID: ${subtaskId}`);
                  continue;
                }
        
                const deal = (AllDeals || []).find(
                  deal => deal.Deal_Name === pipeline.DealName
                );
        
                if (!deal) {
                  console.error(`Deal not found for Subtask ID: ${subtaskId}`);
                  continue;
                }
        
                // Find the task object containing the subtask
                const task = pipeline.Tasks.find(task =>
                  (task.SubTasks || []).some(subtask => subtask.SubTaskROWID === subtaskId)
                );
        
                if (!task) {
                  console.error(`Task not found for Subtask ID: ${subtaskId}`);
                  continue;
                }
        
                // Find the specific subtask object
                const subtask = task.SubTasks.find(subtask => subtask.SubTaskRowId === subtaskId);
        
                if (!subtask) {
                  console.error(`Subtask not found in task for Subtask ID: ${subtaskId}`);
                  continue;
                }
                const taskType = task?.SubTaskROWID ? "Sub Task" : "Task"
                let zuidArr = [];
              let text = '';
              if(field == "Assignee"){
                text = '';
                zuidArr.push(e);
              }else if(field == "Supervisor"){
                text = `assigned you as supervisor in ${taskType}`
                zuidArr.push(e)
              }else if(field == "Priority"){
                const oldPriorityColor = getPriorityValue(task.Priority); // Get color for old priority
                const newPriorityColor = getPriorityValue(e); // Get color for new priority
                text = (
                  <>
                    changed priority from{' '}
                    <span style={{ color: oldPriorityColor, fontWeight: 'bold' , whiteSpace:"nowrap"}}>
                    <FlagFilled style={{ color: oldPriorityColor }} />{' '}
                      {task.Priority}
                    </span>{' '}
                    to{' '}
                    <span style={{ color: newPriorityColor, fontWeight: 'bold', whiteSpace:"nowrap" }}>
                    <FlagFilled style={{ color: newPriorityColor }} />{' '}
                      {e}
                    </span>
                    <span>{' '} in {taskType}</span>
                  </>
                );
                zuidArr = [...zuidArr, task.Assignee, task.Supervisor]
              }

                const renderToHtml = (element) =>
                  require('react-dom/server').renderToString(element);

                handleCreateNotification(zuidArr, state.AllAppUsers,task,deal, taskType,renderToHtml(text), allTasksAndSubtasks)
        
                // await TaskService.SendAssignedNotification(
                //   [e],    // Pass the full subtask object
                //   state.AllAppUsers,
                //   task,
                //   deal,
                //   "Task",
                //   text
                // ).then(() => {
                //   if (getNotification) {
                //     getNotification();
                //   }
                // }).catch(err => console.error(`Error sending notification for Subtask ID: ${subtaskId}`, err));
              }
            }
          } else {
            // Handle TaskTemplate and SubTaskTemplate
            if (selectedIds?.Task?.length > 0) {
              await AwsServerService.updateAssignee(e, selectedIds?.Task, field, "TaskTemplate").then(e=>{
                if(setUpdateFlag){
                  setUpdateFlag(prev => !prev);
                }
              }).catch(e=> console.log("e", e))
            }
            if (selectedIds?.Subtask?.length > 0) {
              await AwsServerService.updateAssignee(e, selectedIds?.Subtask, field, "SubTaskTemplate").then(e=>{
                if(setUpdateFlag){
                  setUpdateFlag(prev => !prev);
                }
              }).catch(e=> console.log("e", e))
            }
          }
        
          // Reset selection and refresh
          setSelectedIds({ Task: [], Subtask: [] });
          setPageRefreshData((prev) => !prev);
        } catch (err) {
          console.error(`Some error occurred updating ${field}`, err);
        }
        
      }
    });
  }
  const [canEdit, setCanEdit] = useState("NO");
  const [canDelete, setCanDelete] = useState("NO");
  const selectedTaskData = useMemo(() => {
    if (!selectedIds?.Task?.length || !allPipelineData?.length) return [];
      return selectedIds.Task.map((item) => {
    const pipeline = allPipelineData.find(pipeline =>
      pipeline.Tasks.some(task => task.TaskROWID === item)
    );
        if (!pipeline) return null;
          if(DealName != undefined && DealName != null){
             DealName.current = pipeline.DealName;
        }
    let task = pipeline.Tasks.find(task => task.TaskROWID === item);
    const {
    Position,
    PPosition,
    CreatedBy,
    CreatedTime,
    ModifiedBy,
    ModifiedTime,
    ...filteredTask
  } = task;

  const viewTaskAccess = getTaskAccess(filteredTask, accessContext, AllUsers, user);
  if(selectedTable == "tasks"){
    setCanEdit(viewTaskAccess[0]?.canEdit || "NO");
    setCanDelete(viewTaskAccess[0]?.canDelete || "NO");
  } else if(selectedTable == "pipelines"){
    const editacc = canAccess(accessContext, "Pipeline", "Edit")
    const canDelete = canAccess(accessContext, "Pipeline", "Delete")
    setCanEdit(!editacc ? "NO" : "YES");
    setCanDelete(!canDelete ? "NO" : "YES");
  }
  return filteredTask;
  })
  }, [selectedIds, allPipelineData]);
  
  const copyTasksToClipboard = async () => {
    try {
      if (selectedTable !== "tasks" || !selectedIds?.Task?.length) {
        await navigator.clipboard.writeText("No tasks selected");
        return;
      }
      const taskPath = selectedIds.Task.map((item) => {
        const pipeline = allPipelineData.find(pipeline =>
          pipeline.Tasks.some(task => task.TaskROWID === item)
        );
        const task = pipeline.Tasks.find(task => task.TaskROWID === item);
        console.log("Selected Task:",task)
        return task ? `${history.location.pathname}/${task.TaskId}` : null;
      })
      console.log("taskPath:- ",taskPath[0])
      await navigator.clipboard.writeText(taskPath[0]);
      message.success('Copied to clipboard!');
 
    } catch (err) {
      console.error("Failed to copy tasks to clipboard: ", err);
    }
  };
  
  return (
    <Row className="bottom-bar" align="start">
      <Col sm={2}>
        <Tag
          closable
          onClose={() => {
            setSelectedIds({ Task: [], Subtask: [] });
          }}
          closeIcon={<CloseOutlined style={{ color: "#000" }} />}
          className="Bottom-Bar-Count-Tag"
        >
          {`${count} Tasks selected`}
        </Tag>
      </Col>
      <Col sm={10} style={{ display: "flex", justifyContent: "space-around" }}>
        {/* <Col> */}
        {/* <Button
          type="link"
          icon={<FontAwesomeIcon icon={faDotCircle} opacity={0.5} />}
        >
          Status
        </Button> */}
        {/* <Button
          type="link"
          icon={<FontAwesomeIcon icon={faPrint} style={{ color: "#fff" }} />}
          // onClick={handlePrint}
        >
          Print
        </Button> */}

        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="1" >Export as CSV</Menu.Item>
              <Menu.Item key="2" >Export as Excel</Menu.Item>
            </Menu>
          }
        >
          <Button
            type="link"
            icon={<FontAwesomeIcon icon={faFileExport} style={{ color: "#fff" }} />}
          >
            Export <DownOutlined />
          </Button>
        </Dropdown>
        {/* </Col> */}
        {/* <Col> */}
        <UserPicker
        open={canEdit == "NO" ? false : undefined}
          rootClassName={"table-dropdown"}
          className={"No-Border"}
          mode="multiple"
          onChange={(e) => {
            updateDataForFields(e,"Assignee")
          }}
          isbottombar={true}
          placeholder={"Assignees"}
        />
        {/* </Col> */}
        {/* <Col> */}
<Tooltip title="Project Manager">
  <div className="project-manager-tooltip-wrapper">
    <UserPicker
      open={canEdit == "NO" ? false : undefined}
      rootClassName={"table-dropdown"}
      className={"No-Border"}
      mode="multiple"
      onChange={(e) => updateDataForFields(e, "Supervisor")}
      isbottombar={true}
      placeholder="Project Manager"
    />
  </div>
</Tooltip>
        {/* </Col> */}
        {/* <Col> */}
        <Select
          open={canEdit == "NO" ? false : undefined}
          className="No-Border priority-icon white-placeholder"
          name="Priority"
          placeholder="Priority"
          style={{
            width: 200,
            "::placeholder": { color: "#fff" },
            ...(canEdit != "NO"
              ? {} : { cursor: "not-allowed", opacity: 0.6 })
          }}
          onMouseDown={(e) => {
            if (canEdit == "NO") {
              e.preventDefault();
              e.stopPropagation();
              message.error("Permission Denied");
              return;
            }
          }}
          onChange={(e) => {
            updateDataForFields(e,"Priority")
          }}
          rootClassName="table-dropdown"
          optionLabelProp="icon"
        >
          <Option
            value="Not Set"
            icon={<span style={{ color: "#fff" }}>{"Priority"}</span>}
          >
            <FlagFilled style={{ color: getPriorityValue("Not Set") }} /> Not
            Set
          </Option>
          <Option
            value="Low"
            icon={<span style={{ color: "#fff" }}>{"Priority"}</span>}
          >
            <FlagFilled style={{ color: getPriorityValue("Low") }} /> Low
          </Option>
          <Option
            value="Medium"
            icon={<span style={{ color: "#fff" }}>{"Priority"}</span>}
          >
            <FlagFilled style={{ color: getPriorityValue("Medium") }} /> Medium
          </Option>
          <Option
            value="High"
            icon={<span style={{ color: "#fff" }}>{"Priority"}</span>}
          >
            <FlagFilled style={{ color: getPriorityValue("High") }} /> High
          </Option>
        </Select>
        {/* </Col> */}
        {/* <Col> */}
        {/* <Button
          type="link"
          icon={<FontAwesomeIcon icon={faCalendarAlt} opacity={0.5} />}
        >
          Dates
        </Button> */}
        {/* </Col> */}
        {/* <Col> */}
        {/* <Button
          type="link"
          icon={<FontAwesomeIcon icon={faArrowRight} opacity={0.5} />}
        >
          Move/Add
        </Button> */}
        {/* </Col> */}
        {/* <Col> */}
        <Button
          type="link"
          icon={<FontAwesomeIcon icon={faCopy} opacity={0.5} />}
          disabled = {count > 1}
          onClick={copyTasksToClipboard}
        >
          Copy
        </Button> 
        <RenderSettingsPopoverContent
          taskModalState = {""}
          taskData = {selectedTaskData[0]}
          setTaskData = {{}}
          taskEmptyTemplate = {{
              TaskName: "",
              TaskDescription: "",
              Priority: "Not Set",
              Assignee: "",
              Supervisor: "",
              PipelineROWID: "",
              DueDate: new Date(),
              StartDate:new Date(),
              Account: "",
              Project: "",
              TaskTemplateId: "",
              TaskStatus:1,
              // TaskFlowId:'1',
              TimeEstimate: "",
              SubTasks: [],
              CheckList: [],
              InputFields:[],
              LookUpFields:[],
              TaskFlowObject:null,
            }}
          setPageRefreshData = {setPageRefreshData}
          setOpen = {canAccess(accessContext, "Tasks", "Create") ? true : false}
          selectedTable = {selectedTable}
          module = "bottomBar"
          count = {count}
          setSelectedIds = {setSelectedIds}
        />
        {/* </Col> */}
        {/* <Col> */}
        <Button
          type="link"
          style={canDelete != "NO" ? {} : {cursor: "not-allowed", opacity: 0.6}}
          icon={
            <FontAwesomeIcon
              icon={faTrashAlt}
              className="bottombar-delete"
              style={{ cursor: "pointer" }}
            />
          }
          onClick={ ()=>{
            if(canDelete != "NO"){
              DeleteTasks()
            } else{
              message.error("Permission Denied");
            }
          }
          }
        >
          Delete
        </Button>
        {/* </Col> */}
      </Col>
    </Row>
  );
};

export default BottomBar;
